export const linkedin = {
  linkedin: {
    shape:
      '<path fill="#3d3d3d" d="M23.5 17.53v5.24h-3.23v-4.92c0-1.21-.47-2.04-1.61-2.04-.88 0-1.42.57-1.62 1.08a2.29 2.29 0 0 0-.13.77v5.11h-3.23v-9.13h3.23v1.27a3.2 3.2 0 0 1 2.9-1.53c2.08 0 3.7 1.34 3.7 4.15zm-13.18-8.3c-1.08 0-1.82.7-1.82 1.6s.67 1.6 1.75 1.6c1.14 0 1.82-.71 1.82-1.6.06-.96-.61-1.6-1.75-1.6zM8.7 22.77h3.23v-9.13H8.7v9.13z"/>',
    viewBox: [0, 0, 32, 32],
  },
};
